'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(e);
        for(o = 0; o < d.length; o++)r = d[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, d = Object.keys(e);
    for(o = 0; o < d.length; o++)r = d[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const Hidden = renderWithRef('Hidden', null, (r, d)=>{
    useComponentStylesLoaded('Hidden', SWAN_STYLE_KEY_MAP.hidden);
    let { children: s, xs: i = false, sm: a = false, md: l = false, lg: p = false, xl: c = false } = r, m = _object_without_properties(r, [
        "children",
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ]), u = new Set();
    return i && u.add('swan-hidden-xs'), a && u.add('swan-hidden-sm'), l && u.add('swan-hidden-md'), p && u.add('swan-hidden-lg'), c && u.add('swan-hidden-xl'), jsx(RenderComp, {
        root: "div",
        forwardedRef: d,
        classNames: u,
        props: m,
        children: s
    });
});

export { Hidden };
